import { AuthenticationService } from "@alfresco/adf-core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Component, EventEmitter, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SecurityProfileService } from "app/service/securityProfile/securityProfile.service";
import { PermissoesService } from "app/service/usuario/permissoes.service";
import * as CryptoJS from "crypto-js";
import { environment } from "environments/environment";

import { LoginComponent } from "../login/login.component";

@Component({
  selector: "app-validate-code",
  templateUrl: "./validate-code.component.html",
  styleUrls: ["./validate-code.component.scss"],
})
export class ValidateCodeComponent implements OnInit {
  errorAlert = false;
  currYear = new Date().getFullYear();
  boxMessage: string | null = null;
  hasNewBoxMessage = false;
  isErrorMessage = false;
  newMessage: boolean = false;
  message: string = "";
  timeToEnableResendCode = 0;
  codeReceived = new FormControl("", [
    Validators.required,
    Validators.pattern("^[0-9]*$"),
  ]);
  apiURL = environment.API;
  apiURLPublic = environment.APIpublic;
  userId: string;
  private usuarioAutenticado = false;
  user: any;
  delay: any = 0;
  mostrarMenuEmitter = new EventEmitter<boolean>();
  key: string;
  redirectTo: "SURFACE" | "RM" | "WORKSPACE" = "SURFACE";
  mode: "TWO_FACTOR" | "RESET_PASS" = "RESET_PASS";
  phoneNumber: string | null = null;
  hidePass = true;
  hideConf = true;
  sendCodeStatus: "LOADING" | "SENDED" | "ERROR" = "LOADING";

  msgLetter = document.getElementById("letter");
  msgCapital = document.getElementById("capital");
  msgNumber = document.getElementById("number");
  msgLength = document.getElementById("length");

  classNumber = "invalid";
  classLetter = "invalid";
  classCapital = "invalid";
  classLength = "invalid";
  classEspecial = "invalid";

  isValidateCodeClosed = false;
  isChangePasswordOpen = false;
  loading = false;
  resendBtnMsg = "Reenviar Código";
  interval: NodeJS.Timer;
  isResendBtnDisabled = true;
  secsLeft: number;
  password: string;
  clienteId;
  deData: CryptoJS.lib.WordArray;
  basicAuth: string;
  ticket: string;

  constructor(
    private permissoesService: PermissoesService,
    private authService: AuthenticationService,
    private httpCliente: HttpClient,
    private securityProfileService: SecurityProfileService,
    private router: Router,
    private route: ActivatedRoute,
    private loginComponent: LoginComponent
  ) {
    this.route.queryParams.subscribe((params) => {
      this.userId = params["userid"];
      this.redirectTo = params["r"];
      this.mode = params["m"];
      this.ticket = params["t"];
      this.password = CryptoJS.AES.decrypt(params["g"], this.ticket).toString(
        CryptoJS.enc.Utf8
      );
      if (!this.userId || !this.mode || !this.password)
        return this.router.navigate(["/login"]);
      if (this.mode === "TWO_FACTOR" && !this.password) {
        return this.router.navigate(["/login"]);
      }

      switch (this.mode) {
        case "RESET_PASS": //se o usuário está em processo de redefinição de senha
          // return this.verificarSeUserDuasEtapas(this.userId, this.key);
          return this.router.navigate(["/login"]);

        case "TWO_FACTOR": //se usuario possui 2 fatores de autenticação
          return this.sendCodeToAuth();
        default:
          break;
      }
    });
  }

  async ngOnInit() {
    localStorage.removeItem("tokenAuth");
    localStorage.removeItem("ticket-ECM");
    sessionStorage.removeItem("tokenAuth");
    sessionStorage.removeItem("ticket-ECM");
  }

  handleResendBtn() {
    if (this.timeToEnableResendCode === 0) {
      this.timeToEnableResendCode = new Date().getTime() + 20000;
    }
    this.isResendBtnDisabled = true;
    this.interval = setInterval(() => {
      let now = Date.now();
      let diff = new Date(this.timeToEnableResendCode).getTime() - now;

      this.secsLeft = Math.floor((diff % (1000 * 60)) / 1000);
      this.resendBtnMsg = `Aguarde ${this.secsLeft} segundos.`;

      if (diff <= 1001) {
        this.secsLeft = 0;
        this.resendBtnMsg = "Reenviar código.";

        clearInterval(this.interval);
        this.isResendBtnDisabled = false;
      }
    }, 1000);
  }

  sendCodeToAuth() {
    if (!this.userId || this.mode != "TWO_FACTOR") {
      this.sendCodeStatus = "ERROR";
      return this.openBoxMessage("Parâmatros inválidos.", true);
    }

    this.loading = true;
    this.permissoesService
      .enviarCodigoSMSAuthentication(this.userId)
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (!data.isSended) {
            this.sendCodeStatus = "ERROR";
            this.handleResendBtn();
            return this.openBoxMessage(data.message, true);
          }
          this.sendCodeStatus = "SENDED";
          this.phoneNumber = data.mobile;
          this.timeToEnableResendCode = data.timeCanCallAgain;
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.sendCodeStatus = "ERROR";
          this.handleResendBtn();
          console.error(error);
          this.openBoxMessage(
            error.error
              ? error.error
              : "Ocorreu um erro ao enviar a solicitação.",
            true
          );
        },
      });
  }

  getErrorMessage() {
    let controlName = "Código";

    if (this.codeReceived.hasError("required")) {
      return "O " + controlName + " é obrigatório.";
    }
    if (this.codeReceived.hasError("pattern")) {
      return "O " + controlName + " deve ser um número.";
    }

    return "";
  }

  validateCodeAuth() {
    const code = this.codeReceived.value;

    if (this.codeReceived.invalid || code === null) {
      this.codeReceived.markAsTouched();

      return;
    }

    this.loading = true;
    this.permissoesService.verificarCodigoAuth(this.userId, code).subscribe({
      next: (data) => {
        this.loading = false;
        if (!data.isValid) {
          return this.openBoxMessage(data.message, true);
        }

        if (data.isValid) {
          this.openBoxMessage(data.message, false);
          return this.teste();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        console.error(error);
        this.openBoxMessage(
          error.error
            ? error.error
            : "Ocorreu um erro ao enviar a solicitação.",
          true
        );
      },
    });
  }

  // loginAndRedirect() {
  //   console.log(this.loginDataForm);
  //   // const form = new UntypedFormGroup({
  //   //   userId: new UntypedFormControl(this.loginDataForm.userId),
  //   //   password: new UntypedFormControl(this.loginDataForm.password),
  //   // });
  //   const authorization = 'Basic ' + window.btoa(this.loginDataForm.userId + ':' + this.loginDataForm.password);

  //   this.loading = true;
  //   this.permissoesService.getUserNovo(this.loginDataForm.userId, ticket, authorization).subscribe(
  //     (data) => {
  //       this.loading = false;
  //       const ticket = data.entry.id;
  //       const basicAuth = 'Basic ' + window.btoa(ticket);
  //       sessionStorage.setItem('ticket', ticket);
  //       sessionStorage.setItem('ticket-ECM', basicAuth);
  //       sessionStorage.setItem('USERNAME', data.entry.userId);
  //       sessionStorage.setItem('userIdInfo', data.entry.userId);
  //       this.getAuthBasic();
  //       // this.LoginSucess(this.loginDataForm.userId);
  //       return this.redirect();
  //     },
  //     (error) => {
  //       this.loading = false;
  //       this.openBoxMessage(
  //         error.error ?? 'Ocorreu um erro ao realizar o login.',
  //         true
  //       );
  //     }
  //   );
  // }

  teste() {
    this.authService.login(this.userId, this.password).subscribe(
      (data) => {
        const ticket = this.ticket;
        const userId = localStorage.getItem("APS_USERNAME");

        sessionStorage.setItem("ticket-ECM", ticket);
        sessionStorage.setItem("ACS_USERNAME", userId);
        this.getAuthBasic();
        this.doLogin(data.ticket);
        this.resetAttempts(this.userId);

        this.usuarioAutenticado = true;
        this.mostrarMenuEmitter.emit(true);
        // const headers = new HttpHeaders().set(
        //   "ticket",
        //   sessionStorage.getItem("ticket-ECM")
        // );
      },
      (err) => {
        this.loading = false;
        this.mostrarMenuEmitter.emit(false);
        this.usuarioAutenticado = false;
        if (err.status === 403) {
          this.loading = false;
          this.message = "Usuário ou senha incorretos";
          this.newMessage = true;
          setTimeout(() => {
            this.newMessage = false;
          }, 10000);
          this.setSecurityProfileById(this.userId);
        } else {
          this.loading = false;
          this.message =
            "PCdoc RM está fora do ar, tente novamente em instantes!";
          this.newMessage = true;
          setTimeout(() => {
            this.newMessage = false;
          }, 10000);
        }
        this.showAlertExcluir();
      }
    );
  }

  setSecurityProfileById(userId: string) {
    this.loading = true;
    this.securityProfileService.setSecurityProfileById(userId, "RM").subscribe({
      next: (data) => {
        console.log(data);
        if (data.message != "null") {
          this.loading = false;
          this.message = data.message;
          this.newMessage = true;
          setTimeout(() => {
            this.newMessage = false;
          }, 10000);
        } else {
          this.loading = false;
          this.message = data.message;
          this.newMessage = true;
          setTimeout(() => {
            this.newMessage = false;
          }, 10000);
        }

        if (data.delay > 0) {
          this.loading = false;
          (this.message =
            "Aguarde" +
            " " +
            data.delay +
            " " +
            "segundos, para tentar novamente"),
            (this.newMessage = true);
          this.loading = false;
          setTimeout(() => {
            this.newMessage = false;
          }, 10000);

          this.startDelay(data.delay);
        }
      },
      error: (err) => {
        this.loading = false;
        this.message = err.error.message;
        this.newMessage = true;
        setTimeout(() => {
          this.newMessage = false;
        }, 10000);
        // }
        console.error(err);
      },
    });
  }

  startDelay(delay: any) {
    let seconds = delay;

    const setInter = setInterval(() => {
      if (seconds <= 0) {
        clearInterval(setInter);
        sessionStorage.removeItem("delay");
      } else {
        seconds--;
        sessionStorage.setItem("delay", seconds.toString());
        this.delay = seconds;
      }
    }, 1000);
  }

  resetAttempts(userName: string) {
    this.securityProfileService.resetAttempts(userName).subscribe({
      next: (data) => {},
      error: (err) => {
        console.error(err);
      },
    });
  }

  doLogin(ticket: string) {
    const formLogin = new FormData();
    formLogin.append("userId", this.userId);
    formLogin.append("password", this.password);

    const headers = new HttpHeaders().set("ticket", ticket);

    this.httpCliente
      .post(this.apiURLPublic + "/get-user", formLogin, { headers })
      .subscribe(
        (data) => {
          this.getUserNovo(this.userId, ticket, this.basicAuth);
        },
        (err) => {
          console.error(err);
          this.loading = false;
        }
      );
  }

  getUserNovo(userId: String, ticket: any, authorization: any) {
    this.permissoesService.getUserNovo(userId, ticket, authorization).subscribe(
      (data) => {
        const arrayAuthority: any[] = [];
        this.user = data;
        this.user.forEach((el) => {
          arrayAuthority.push(el.authority);
        });
        this.setItemAuthority("authority", arrayAuthority);
        const params = sessionStorage.getItem("params");
        if (params !== null && params !== "undefined") {
          console.log(params.length);
          if (params.length < 20) {
            this.clienteId = params;
            this.getPermissionCliente(this.clienteId);
            this.redirect();
          } else {
            this.clienteId = params;
            this.deData = CryptoJS.AES.decrypt(
              decodeURIComponent(this.clienteId),
              "pcdoc"
            );
            this.clienteId = JSON.parse(
              this.deData.toString(CryptoJS.enc.Utf8)
            );
            console.log(this.clienteId);
            this.getPermissionCliente(this.clienteId);
            this.redirect();
          }
        } else {
          this.redirect();
        }
      },
      (err) => {
        console.error(err);
        this.changeUserPass(err.status, userId, ticket, authorization);
      }
    );
  }

  changeUserPass(errStatus, userId, ticket, authorization) {
    const isLoggedAlfresco = this.authService.isLoggedIn();

    if (errStatus === 401 && isLoggedAlfresco) {
      this.permissoesService
        .changeUserPassword(userId, this.userId, ticket, isLoggedAlfresco)
        .subscribe(
          (data) => {
            this.getUserNovo(userId, ticket, authorization);
          },
          (err) => {
            console.log(err);
            this.loading = false;
          }
        );
    } else {
      this.loading = false;
    }
  }

  getPermissionCliente(idCliente: number) {
    const headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("ticket", this.ticket)
      .set("Authorization", sessionStorage.getItem("tokenAuth"));

    this.httpCliente
      .get<any>(
        this.apiURL + `/permission/get-permission-por-cliente/${idCliente}`,
        { headers }
      )
      .subscribe(
        (data) => {
          console.log("entrei");
          const arrayAuthorityCliente: any[] = [];
          data.forEach((el) => {
            arrayAuthorityCliente.push(el.authority);
          });
          this.setItemAuthority("authority-Empresa", arrayAuthorityCliente);
        },
        (err) => {
          console.log(err);
          this.loading = false;
          if (err.status === 401) {
            this.loading = false;
          }
        }
      );
  }

  showAlertExcluir(): void {
    // show box msg
    this.errorAlert = true;
    // wait 3 Seconds and hide
    setTimeout(
      function () {
        this.errorAlert = false;
      }.bind(this),
      4000
    );
  }

  setItemAuthority(key, value) {
    const store: any = CryptoJS.AES.encrypt(JSON.stringify(value), this.ticket);
    return sessionStorage.setItem(key, store);
  }

  redirect() {
    const pastRouter = sessionStorage.getItem("routerpast");
    console.log("pastRouter    :" + pastRouter);
    if (pastRouter !== "/login" && pastRouter !== "/") {
      console.log(pastRouter);
      // this.router.navigate([`${pastRouter}`]);
      if (pastRouter === null) {
        window.location.href = "/home";
        // this.router.navigate(['/home']);
      } else {
        window.location.href = `${pastRouter}`;
        // this.router.navigate([`${pastRouter}`]);
      }
    } else {
      window.location.href = "/home";
      // this.router.navigate(['/home']);
    }
    sessionStorage.removeItem("routerpast");
  }

  getAuthBasic() {
    const userId = this.userId;
    const password = this.password;

    this.basicAuth = "Basic " + window.btoa(userId + ":" + password);
    sessionStorage.setItem("tokenAuth", this.basicAuth);
  }

  openBoxMessage(msg: string, isError: boolean) {
    this.boxMessage = msg;
    this.hasNewBoxMessage = true;
    this.isErrorMessage = isError;
    setTimeout(() => {
      this.hasNewBoxMessage = false;
    }, 10000);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/validate-code/validate-code.component.ts